module.exports = __webpack_public_path__ + "img/white-iphone-in-portrait-position-macbook-pro-responsive-png-mockup-a12407.637dad48.png";